<template>
  <div :id="modalId" class="modal" :data-backdrop="disableBackdrop ? '' : 'static'">
    <div class="modal__content">
      <div class="p-5 text-center">
        <xCircleIcon v-if="status === 'danger'" class="w-16 h-16 text-theme-6 mx-auto mt-3" />
        <helpCircleIcon v-if="status === 'warning'" class="w-16 h-16 text-theme-11 mx-auto mt-3" />
        <div class="text-3xl mt-5">{{ $t('confirmDialog.title') }}</div>
        <div class="text-gray-600 mt-2">
          {{ $t('confirmDialog.description') }}
        </div>
      </div>
      <div class="px-5 pb-8 text-center">
        <Button
          type="button"
          @click="onCancel"
          class="w-24 border text-gray-700 dark:border-dark-5 dark:text-gray-300 mr-1"
        >
          {{ $t('text.cancel') }}
        </Button>
        <Button
          type="button"
          @click="onSubmit"
          :loading="loading"
          :class="[
            'w-24 text-white',
            { 'bg-theme-6': status === 'danger', 'bg-theme-11': status === 'warning' },
          ]"
        >
          {{ $t('text.yes') }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/ui/button/Button';

export default {
  name: 'ConfirmDialog',

  components: { Button },

  props: {
    modalId: {
      type: String,
      default: 'delete-confirm-dialog',
    },
    disableBackdrop: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: 'danger',
    },
  },

  methods: {
    onCancel() {
      cash(`#${this.modalId}`).modal('hide');
      this.$emit('cancelled');
    },
    onSubmit() {
      this.$emit('ok');
    },
  },
};
</script>
